export default __webpack_public_path__ + "static/media/ic_cart.d2534df4.svg";